<div class="package-tracking-popup-container">
  <div class="header">
    <div class="header-left">
      <ion-row class="label">
        {{ CONSTANTS.TRACKING_NUMBER }}
      </ion-row>
      <ion-row class="custom-searchbar">
        <ion-col>
          <ion-input
            #searchModel="ngModel"
            name="searchQuery"
            class="tracking-number-input"
            maxlength="18"
            [(ngModel)]="searchQuery"
            [ngModelOptions]="{ standalone: true }"
            (keypress)="keyPress($event)"
          >
          </ion-input>
          <div
            class="clear-search-text-icons"
            onkeypress="clearSearch()"
            (click)="clearSearch()"
          >
            <img
              alt="clear-search"
              [src]="searchQuery ? IMAGES.CLOSE_BLACK : IMAGES.SEARCH"
              [ngClass]="{ 'active-click': searchQuery }"
            />
          </div>
        </ion-col>
      </ion-row>
    </div>
    <ion-button fill="clear" class="icon-btn" (click)="dialogRef.close()">
      <ion-icon [src]="IMAGES.CLOSE_BLACK" class="icon"></ion-icon>
    </ion-button>
  </div>
  <div class="popup-body">
    <div class="tab-wrapper">
      <ion-segment
        class="segment"
        [value]="tab"
        (ionChange)="updateTab($event)"
      >
        <ion-segment-button class="segment-btn" [value]="tabs.INQUIRY">
          <ion-label>{{ CONSTANTS.PACKAGE_INQUIRY }}</ion-label>
        </ion-segment-button>
        <ion-segment-button class="segment-btn" [value]="tabs.HISTORY">
          <ion-label>{{ CONSTANTS.PACKAGE_HISTORY }}</ion-label>
        </ion-segment-button>
      </ion-segment>
    </div>
    <div class="seperator-border"></div>
    @switch (tab) {
      @case (tabs.INQUIRY) {
        <app-package-inquiry [detailsData]="details"></app-package-inquiry>
      }
      @case (tabs.HISTORY) {
        <app-package-history
          [packageHistory]="history"
          [trackingNumber]="searchQuery"
        ></app-package-history>
      }
    }
  </div>
</div>
